module.exports = __webpack_public_path__ + "img/DNARepair-PRCA_SpatialResearch.99656556.png";